import { render, staticRenderFns } from "./ColSpan.vue?vue&type=template&id=4c98dfb6&"
import script from "./ColSpan.vue?vue&type=script&lang=js&"
export * from "./ColSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports